import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

interface SwaggerDocProps {
  spec: any;
}

export function SwaggerDoc({ spec }: SwaggerDocProps) {
  // Get the API base URL from environment variables or use default
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

  // Ensure the spec has the correct server URL
  const enhancedSpec = {
    ...spec,
    servers: [
      {
        url: apiBaseUrl,
        description: "Production API server",
      },
    ],
  };

  return (
    <div className="swagger-wrapper">
      <SwaggerUI
        spec={enhancedSpec}
        docExpansion="list"
        defaultModelsExpandDepth={-1}
        displayRequestDuration
        filter
        tryItOutEnabled={true}
      />
    </div>
  );
}
